import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Link, useParams } from 'react-router-dom';
import { Form, Field, FormElement } from "@progress/kendo-react-form";
import { Button } from "@progress/kendo-react-buttons";
import { Dialog } from "@progress/kendo-react-dialogs";
import { LoadingPanel } from "./LoadingPanel";
import { addNotificationWithTimeout } from '../app/addNotificationWithTimeout';
import { handleResponse } from '../app/handleResponse';
import { getCSRFToken } from '../app/getCSRFToken';

import {
    FormInput
} from "./forms/form-components";

import './Login.scss';

export const ResetPassword = () => {
    const dispatch = useDispatch();

    const [isLoading, setIsLoading] = useState(false);
    const [isPasswordResetComplete, setIsPasswordResetComplete] = useState(false);
    const [isTokenValid, setIsTokenValid] = useState(true);

    const { token } = useParams();

    const passwordValidator = (value) => {
        if (!value) {
            return "This field is required";
        }

        if (value.length < 8) {
            return "The minimum length is 8 characters";
        }

        if (value.length > 50) {
            return "The maximum length is 50 characters";
        }

        return "";
    }

    const handleSubmit = (dataItem) => {
        if (dataItem.password !== dataItem.confirmPassword) {
            addNotificationWithTimeout(dispatch, "error", "The password and confirmation don't match");
            return;
        }

        setIsLoading(true);

        dataItem.token = token;

        fetch(`/api/resetPassword`,
            {
                method: "POST",
                headers: {
                    'Content-Type': 'application/json',
                    "X-XSRF-TOKEN": getCSRFToken(),
                },
                body: JSON.stringify(dataItem),
            })
            .then(handleResponse)
            .then(result => {
                setIsLoading(false);
                setIsPasswordResetComplete(true);
            })
            .catch(error => {
                addNotificationWithTimeout(dispatch, "error", error.message);
                setIsLoading(false);
            });
    }

    const validateToken = () => {
        var dataItem = {
            "token": token,
        };

        fetch(`/api/validateResetPasswordToken`,
            {
                method: "POST",
                headers: {
                    'Content-Type': 'application/json',
                    "X-XSRF-TOKEN": getCSRFToken(),
                },
                body: JSON.stringify(dataItem),
            })
            .then(handleResponse)
            .catch(error => {
                setIsTokenValid(false);
            });
    }

    useEffect(() => {
        const baseTitle = "OTT";
        document.title = "Reset password";

        if (baseTitle !== "") {
            document.title += ` | ${baseTitle}`;
        }

        validateToken();
    }, []);

    return (
        <>
            <Dialog className="resetPassword">
                {isLoading ? <LoadingPanel /> : null}

                <h1>
                    Reset password
                </h1>

                {isTokenValid === false
                    ?
                    <div>
                        Your reset password link has expired. <Link to="/forgotPassword">Click here to start over.</Link>
                    </div>
                    :
                    (isPasswordResetComplete
                        ?
                        <div>
                            Your password has been updated. <Link to="/login">Click here to log in.</Link>
                        </div>
                        :
                        <Form
                            onSubmit={handleSubmit}
                            render={(formRenderProps) => (
                                <FormElement>
                                    <fieldset className={"k-form-fieldset"}>
                                        <div className="mb-3 noFormField">
                                            Enter your new password
                                        </div>
                                        <Field
                                            id={"password"} 
                                            name={"password"}
                                            label="New password"
                                            component={FormInput}
                                            validator={passwordValidator}
                                            type={"password"}
                                            showPasswordToggle={true}
                                            autoComplete="new-password"
                                            aria-label="New password"
                                        />
                                        <Field
                                            id={"confirmPassword"}
                                            name={"confirmPassword"}
                                            label="Confirm password"
                                            component={FormInput}
                                            validator={passwordValidator}
                                            type={"password"}
                                            showPasswordToggle={true}
                                            autoComplete="new-password"
                                            aria-label="Confirm password"
                                        />
                                    </fieldset>
                                    <div className="k-form-buttons">
                                        <Button
                                            themeColor={"primary"}
                                            type={"submit"}
                                            disabled={!formRenderProps.allowSubmit}
                                        >
                                            Update
                                        </Button>
                                    </div>
                                </FormElement>
                            )}
                        />
                    )
                }
            </Dialog>
        </>
    );
}